module.exports = __webpack_public_path__ + "Roboto-Light.eot";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/fonts/roboto/Roboto-Light.eot
// module id = 28
// module chunks = 0